import {
  ContractApprovalPermissions,
  CollectionApprovalPermissions,
  BillingPermissions,
  BillingPeriodPermissions,
  PaymentPermissions,
  DisbursementPermissions,
  ClientPermissions,
  ContractPermissions,
  ServiceCategoryPermissions,
  ServicePermissions,
  DocumentTypePermissions,
  BusinessStylePermissions,
  BusinessTypePermissions,
  AccountClassPermissions,
  AccountTitlePermissions,
  ChargePermissions,
  RDOPermissions,
  LocationPermissions,
  TaxTypePermissions,
  AccountTypePermissions,
  PersonnelPermissions,
  UserGroupPermissions,
  BankPermissions,
  EwalletPermissions,
  CreditMemoPermissions,
  TaxFundPermissions,
  GeneralJournalPermissions,
  ReportPermissions
} from '../../helpers/enum'

export default[
  {
      title: 'Home',
      path: '/dashboard',
      isVisible: true,
      children: []
  },
  {
    title: 'Approvals',
    path: '/approvals',
    isVisible: true,
    permissionIds: [ 
      ...ContractApprovalPermissions.getIds(),
      ...CollectionApprovalPermissions.getIds()
    ],
    children: [
      {
        title: 'Contracts',
        path: '/approvals/contracts',
        permissionIds: [
          ...ContractApprovalPermissions.getIds(),
        ]
      },
      // {
      //   title: 'Disbursements',
      //   path: '/approvals/disbursements'
      // },
      {
        title: 'Collections',
        path: '/approvals/collections',
        permissionIds: [
          ...CollectionApprovalPermissions.getIds(),
        ]
      }
    ]
  },
  {
    title: 'transactions',
    path: '/transactions',
    isVisible: true,
    permissionIds: [
      ...BillingPermissions.getIds(),
      ...BillingPeriodPermissions.getIds(),
      ...PaymentPermissions.getIds(),
      ...DisbursementPermissions.getIds(),
      ...CreditMemoPermissions.getIds(),
      ...TaxFundPermissions.getIds()
    ],
    children: [
      {
        title: 'Billings',
        path: '/transactions/billing',
        permissionIds: [
          ...BillingPermissions.getIds(),
        ]
      },
      {
        title: 'Billing Periods',
        path: '/transactions/billing-period',
        permissionIds: [
          ...BillingPeriodPermissions.getIds(),
        ]
      },
      {
        title: 'Collections',
        path: '/transactions/collection',
        permissionIds: [
          ...PaymentPermissions.getIds(),
        ]
      },
      {
        title: 'Disbursements',
        path: '/transactions/disbursement',
        permissionIds: [
          ...DisbursementPermissions.getIds(),
        ]
      },
      {
        title: 'Credit Memo',
        path: '/transactions/credit-memo',
        permissionIds: [
          ...CreditMemoPermissions.getIds(),
        ]
      },
      {
        title: 'Tax Fund',
        path: '/transactions/tax-fund',
        permissionIds: [
          ...TaxFundPermissions.getIds(),
        ]
      },
      {
        title: 'General Journal',
        path: '/transactions/general-journal',
        permissionIds: [
          ...GeneralJournalPermissions.getIds(),
        ]
      }
    ]
  },
  {
    title: 'Masterfiles',
    path: '/masterfiles',
    isVisible: true,
    permissionIds: [
      ...ClientPermissions.getIds(),
      ...ContractPermissions.getIds(),
      ...AccountTypePermissions.getIds(),
      ...ServiceCategoryPermissions.getIds(),
      ...ServicePermissions.getIds(),
      ...DocumentTypePermissions.getIds(),
      ...BusinessStylePermissions.getIds(),
      ...BusinessTypePermissions.getIds(),
      ...AccountClassPermissions.getIds(),
      ...AccountTitlePermissions.getIds(),
      ...ChargePermissions.getIds(),
      ...RDOPermissions.getIds(),
      ...LocationPermissions.getIds(),
      ...TaxTypePermissions.getIds(),
      ...BankPermissions.getIds(),
      ...EwalletPermissions.getIds()
    ],
    children: [
      {
        title: 'Clients',
        path: '/masterfiles/client',
        permissionIds: [
          ...ClientPermissions.getIds()
        ]
      },
      {
        title: 'Contracts',
        path: '/masterfiles/contract',
        permissionIds: [
          ...ContractPermissions.getIds()
        ]
      },
      {
        title: 'Account Types',
        path: '/masterfiles/account-type',
        permissionIds: [
          ...AccountTypePermissions.getIds()
        ]
      },
      {
        title: 'Account Classes',
        path: '/masterfiles/account-class',
        permissionIds: [
          ...AccountClassPermissions.getIds(),
        ]
      },
      {
        title: 'Account Titles',
        path: '/masterfiles/account-title',
        permissionIds: [
          ...AccountTitlePermissions.getIds(),
        ]
      },
      {
        title: 'Service Categories',
        path: '/masterfiles/service-category',
        permissionIds: [
          ...ServiceCategoryPermissions.getIds()
        ]
      },
      {
        title: 'Services',
        path: '/masterfiles/service',
        permissionIds: [
          ...ServicePermissions.getIds()
        ]
      },
      {
        title: 'Document Types',
        path: '/masterfiles/document-type',
        permissionIds: [
          ...DocumentTypePermissions.getIds()
        ]
      },
      {
        title: 'Business Styles',
        path: '/masterfiles/business-style',
        permissionIds: [
          ...BusinessStylePermissions.getIds()
        ]
      },
      {
        title: 'Business Types',
        path: '/masterfiles/business-type',
        permissionIds: [
          ...BusinessTypePermissions.getIds()
        ]
      },
      {
        title: 'Charges',
        path: '/masterfiles/charge',
        permissionIds: [
          ...ChargePermissions.getIds()
        ]
      },
      {
        title: 'RDO',
        path: '/masterfiles/rdo',
        permissionIds: [
          ...RDOPermissions.getIds()
        ]
      },
      {
        title: 'Locations',
        path: '/masterfiles/location',
        permissionIds: [
          ...LocationPermissions.getIds()
        ]
      },
      {
        title: 'Tax Types',
        path: '/masterfiles/tax-type',
        permissionIds: [
          ...TaxTypePermissions.getIds()
        ]
      },
      {
        title: 'Banks',
        path: '/masterfiles/bank',
        permissionIds: [
          ...BankPermissions.getIds()
        ]
      },
      {
        title: 'E-Wallets',
        path: '/masterfiles/ewallet',
        permissionIds: [
          ...EwalletPermissions.getIds()
        ]
      },
    ]
  },
  {
    title: 'Reports',
    path: '/reports',
    isVisible: true,
    permissionIds: [
      ...ReportPermissions.getIds()
    ],
    children: [
      {
        title: 'Collection(Detailed)',
        path: '/reports/collection-detailed',
        permissionIds: [
          ReportPermissions.COLLECTION_DETAILED.id
        ]
      },
      {
        title: 'Collection(Summary)',
        path: '/reports/collection-summary',
        permissionIds: [
          ReportPermissions.COLLECTION_SUMMARY.id
        ]
      },
      {
        title: 'Client Subsidiary Ledger',
        path: '/reports/client-subsidiary-ledger',
        permissionIds: [
          ReportPermissions.CLIENT_SUBSIDIARY.id
        ]
      },
      {
        title: 'Accounts Receivable Report',
        path: '/reports/accounts-receivable-report',
        permissionIds: [
          ReportPermissions.ACCOUNT_RECEIVABLE.id
        ]
      },
      {
        title: 'Statement of Financial Position',
        path: '/reports/statement-of-financial-position',
        permissionIds: [
          ReportPermissions.STATEMENT_OF_FINANCIAL_POSITION.id
        ]
      },
      {
        title: 'Income Statement',
        path: '/reports/income-statement',
        permissionIds: [
          ReportPermissions.INCOME_STATEMENT.id
        ]
      },
    ]
  },
  {
    title: 'Settings',
    path: '/settings',
    isVisible: true,
    permissionIds: [
      ...PersonnelPermissions.getIds(),
      ...UserGroupPermissions.getIds()
    ],
    children: [
      {
        title: 'Personnels',
        path: '/settings/personnel',
        permissionIds: [
          ...PersonnelPermissions.getIds(),
        ],
      },
      {
        title: 'User Groups',
        path: '/settings/user-group',
        permissionIds: [
          ...UserGroupPermissions.getIds()
        ],
      },
      {
        title: 'Company',
        path: '/settings/company',
        permissionIds: [
          // ...UserGroupPermissions.getIds()
        ],
      },
    ]
  },
  {
    title: 'Profile',
    path: '/profile',
    isVisible: false,
    children: []
  }

]
